import { render } from "./OOCAnalysisResultsPage.vue?vue&type=template&id=17298c0c&scoped=true&ts=true"
import script from "./OOCAnalysisResultsPage.vue?vue&type=script&lang=ts"
export * from "./OOCAnalysisResultsPage.vue?vue&type=script&lang=ts"

import "./OOCAnalysisResultsPage.vue?vue&type=style&index=0&id=17298c0c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17298c0c"]])

export default __exports__